// ENTITY fr.gestionpial.pial.dto.SaveResultDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class SaveResultDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.SaveResultDTO';

  createdIds: number[] | null = [];
  updatedCount: number | null = 0;
  deletedCount: number | null = 0;

  constructor(init?:Partial<SaveResultDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.SaveResultDTO'] = SaveResultDTO;

fields['fr.gestionpial.pial.dto.SaveResultDTO']  = {
    createdIds: 'java.util.List<java.lang.Integer>',
    updatedCount: 'java.lang.Integer',
    deletedCount: 'java.lang.Integer'
};
